import React from 'react'

function NotFound () {
  return(
    <h2>404 NOT FOUND</h2>
  )
}

export default NotFound;